export const INVOICE = 'main';
export const PARTNER = 'partner';
export const EQUIPMENT = 'equipment';
export const CREDIT = 'credit';
export const DEBIT = 'debit';
export const SERVICE = 'service';
export const COMMISSION = 'commission';
export const COMPENSATION = 'cnc';
export const MARGIN_CORRECT = 'mc';
export const PURCHASE = 'purchase_invoice';
export const SALE_AGENT = 'sale_agent_invoice';



// WEBPACK FOOTER //
// ./src/constants/invoiceTypes.js